// import Vue from 'vue'
import Home from '@/views/Home.vue'
import Router from 'vue-router'

// Vue.use(Router)
//防止路由重复报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//路由
export const constantRouterMap = [
    {
        path: '/',
        component: Home,
        children: [
            {
                path: '/',
                component: () => import("@/views/index/Index.vue"),
                meta: {
                    title: "首页",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/about',
                component: () => import("@/views/about/About.vue"),
                meta: {
                    title: "关于我们",
                    id: 1,
                    fatherId: 1
                },
                children: [
                    {
                        path: "/aboutContent",
                        component: () => import("@/views/about/AboutContent.vue"),
                        meta: {
                            title: "企业简介",
                            id: 6,
                            fatherId: 1
                        },
                    },
                    {
                        path: "/aboutHonor",
                        component: () => import("@/views/about/AboutHonor.vue"),
                        meta: {
                            title: "校园环境",
                            id: 7,
                            fatherId: 1
                        },
                    },
                    {
                        path: "/aboutCorporate",
                        component: () => import("@/views/about/AboutCorporate.vue"),
                        meta: {
                            title: "学员风采",
                            id: 7,
                            fatherId: 1
                        },
                    },
                ]
            },
            {
                path: '/recordedLessons',
                component: () => import("@/views/recordedLessons/RecordedLessons.vue"),
                meta: {
                    title: "录播课",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/recordVideo',
                component: () => import("@/views/recordedLessons/RecordVideo.vue"),
                meta: {
                    title: "录播课-视频",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/questionBank',
                component: () => import("@/views/questionBank/QuestionBank.vue"),
                meta: {
                    title: "题库",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/questionDetails',
                component: () => import("@/views/questionBank/QuestionDetails.vue"),
                meta: {
                    title: "答题结果",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/QuestionResult',
                component: () => import("@/views/questionBank/QuestionResult.vue"),
                meta: {
                    title: "答题结果",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/doPracticeProblems',
                component: () => import("@/views/questionBank/DoPracticeProblems.vue"),
                meta: {
                    title: "刷题",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/doPracticeProblems2',
                component: () => import("@/views/questionBank/DoPracticeProblems2.vue"),
                meta: {
                    title: "刷题",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/doPracticeProblems3',
                component: () => import("@/views/questionBank/DoPracticeProblems3.vue"),
                meta: {
                    title: "刷题",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/questionBankList',
                component: () => import("@/views/questionBank/QuestionBankList.vue"),
                meta: {
                    title: "题库列表",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/exam',
                component: () => import("@/views/exam/Exam.vue"),
                meta: {
                    title: "真题模考",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/examDetail',
                component: () => import("@/views/exam/ExamDetail.vue"),
                meta: {
                    title: "真题模考-考试",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/examResult',
                component: () => import("@/views/exam/ExamResult.vue"),
                meta: {
                    title: "真题模考-考试-结果",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/my',
                component: () => import("@/views/my/My.vue"),
                children: [
                    {
                        path: '/myWrongQuestion',
                        component: () => import("@/views/my/MyWrongQuestion.vue"),
                        meta: {
                            title: "错题集",
                            id: 0,
                            fatherId: 0,
                        }
                    },
                    {
                        path: '/myRecord',
                        component: () => import("@/views/my/MyRecord.vue"),
                        meta: {
                            title: "刷题记录",
                            id: 0,
                            fatherId: 0,
                        }
                    },
                    {
                        path: '/myAccountSecurity',
                        component: () => import("@/views/my/MyAccountSecurity.vue"),
                        meta: {
                            title: "账号安全",
                            id: 0,
                            fatherId: 0,
                        }
                    },
                    {
                        path: '/myCertification',
                        component: () => import("@/views/my/MyCertification.vue"),
                        meta: {
                            title: "实名认证",
                            id: 0,
                            fatherId: 0,
                        }
                    }
                ],
                meta: {
                    title: "个人中心",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/login',
                component: () => import("@/views/login/Login.vue"),
                meta: {
                    title: "登录",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/register',
                component: () => import("@/views/login/Register.vue"),
                meta: {
                    title: "注册",
                    id: 0,
                    fatherId: 0,
                }
            },
        ]
    }
]

const router = new Router({
    routes: constantRouterMap
})
export default router